import { GridColumnMenuColumnsChooser, GridColumnMenuSort, GridColumnMenuCheckboxFilter } from '@progress/kendo-react-grid';

/**
 * Column menu tool component for Kendo Grid.
 *
 * @param {Object} props - component props.
 * @param {boolean} props.sortable - whether sorting is enabled.
 * @param {boolean} props.showColumnChooser - whether column chooser is enabled.
 * @param {boolean} props.showCheckboxFilter - whether checkbox filter is enabled.
 * @param {Array} props.data - data array for the grid.
 * @returns {JSX.Element} rendered column menu.
 */
export const ColumnMenu = props => {
    const groupedFields = (props.group || []).map(g => g.field);
    const filteredColumns = (props.columnsState || []).filter(
                col => col.title && col.title.trim().length > 0 && !groupedFields.includes(col.field)
    );

    return (
        <>
            {props.sortable && <GridColumnMenuSort {...props} />}
            {props.showColumnChooser && (
                <GridColumnMenuColumnsChooser
                    {...props}
                    columnsState={filteredColumns}
                />
            )}
            {props.showCheckboxFilter && <GridColumnMenuCheckboxFilter
                                           {...props}
                                           data={props.data || []}
                                           searchBoxFilterOperator="contains"
                                         />
            }
        </>
    );
};